(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-videos"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('customer-videos'))customElements.define('customer-videos',class extends HTMLElement{connectedCallback(){this.life=new AbortController();this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.rf-video-card'),track=this.querySelector('.rf-video-track');if(card&&track)track.scrollTo({left:card.offsetLeft-track.offsetLeft,behavior:'instant'})},{signal:this.life.signal})}disconnectedCallback(){this.life?.abort()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harmony-header"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fall-sale-banner')){
  customElements.define('fall-sale-banner',class extends HTMLElement{
    connectedCallback(){
      this.end=Date.parse(this.dataset.endsAt);
      if(!Number.isFinite(this.end)){this.hidden=true;return;}
      this.hours=this.querySelector('[data-hours]');
      this.minutes=this.querySelector('[data-minutes]');
      this.seconds=this.querySelector('[data-seconds]');
      this.tick=()=>{
        const remaining=Math.max(0,Math.ceil((this.end-Date.now())/1000));
        this.hours.textContent=String(Math.floor(remaining/3600)).padStart(2,'0');
        this.minutes.textContent=String(Math.floor(remaining%3600/60)).padStart(2,'0');
        this.seconds.textContent=String(remaining%60).padStart(2,'0');
        this.hidden=remaining===0;
        if(remaining===0)clearInterval(this.timer);
      };
      this.tick();
      if(!this.hidden)this.timer=setInterval(this.tick,1000);
    }
    disconnectedCallback(){clearInterval(this.timer);}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harmony-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('harmony-product'))customElements.define('harmony-product',class extends HTMLElement{
connectedCallback(){this.life=new AbortController();const signal=this.life.signal;const track=this.querySelector('.hm-slides');const slides=[...this.querySelectorAll('[data-slide]')];const thumbs=[...this.querySelectorAll('[data-go]')];this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;if(b.dataset.hmDialog)this.querySelector(`[data-hm-modal="${b.dataset.hmDialog}"]`)?.showModal();if(b.hasAttribute('data-hm-close'))b.closest('dialog').close();if(b.hasAttribute('data-go'))track.scrollTo({left:track.clientWidth*Number(b.dataset.go),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});if(b.hasAttribute('data-hm-qty')){const i=this.querySelector('[name="quantity"]');i.value=Math.max(1,Math.min(20,Number(i.value||1)+Number(b.dataset.hmQty)));i.dispatchEvent(new Event('change',{bubbles:true}))}if(b.hasAttribute('data-hm-scroll')){const target=this.querySelector('.hm-buy-row,.hm-preview-buy');target.scrollIntoView({behavior:'smooth',block:'center'});target.querySelector('[data-hm-add]')?.focus({preventScroll:true})}},{signal});track.addEventListener('scroll',()=>{const n=Math.round(track.scrollLeft/track.clientWidth);thumbs.forEach((t,i)=>{t.classList.toggle('is-active',i===n);t.setAttribute('aria-pressed',String(i===n))});this.querySelector('[data-current]').textContent=n+1},{signal,passive:true});this.querySelectorAll('dialog').forEach(d=>d.addEventListener('click',e=>{if(e.target!==d)return;const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close()},{signal}));this.querySelector('.hm-variant')?.addEventListener('change',e=>{const o=e.target.selectedOptions[0];this.querySelectorAll('[data-hm-add]').forEach(b=>{b.disabled=o.dataset.available!=='true';b.firstElementChild.textContent=b.disabled?b.dataset.soldLabel:b.dataset.buyLabel});this.querySelectorAll('[data-sale-price]').forEach(p=>p.textContent=o.dataset.price);this.querySelectorAll('[data-compare-price]').forEach(p=>{p.textContent=o.dataset.compare;p.hidden=!o.dataset.compare});this.querySelectorAll('.cf-price-note').forEach(p=>p.hidden=true)},{signal});const target=this.querySelector('.hm-buy-row,.hm-preview-buy');const updateSticky=()=>{if(target)this.querySelector('.hm-sticky-buy').classList.toggle('is-visible',target.getBoundingClientRect().bottom<0)};this.observer=new IntersectionObserver(updateSticky);if(target)this.observer.observe(target);this.ownerDocument.defaultView.addEventListener('resize',updateSticky,{signal});this.ownerDocument.defaultView.addEventListener('scroll',updateSticky,{signal,passive:true});updateSticky()}disconnectedCallback(){this.life?.abort();this.observer?.disconnect()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harmony-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('customer-proof'))customElements.define('customer-proof',class extends HTMLElement{connectedCallback(){this.life=new AbortController();this.addEventListener('click',e=>{const b=e.target.closest('[data-review-dir]');if(!b)return;const track=this.querySelector('.cf-review-track'),card=track.firstElementChild;track.scrollBy({left:(card.getBoundingClientRect().width+20)*Number(b.dataset.reviewDir),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})},{signal:this.life.signal});this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.cf-review-card'),track=this.querySelector('.cf-review-track');if(card&&track)track.scrollTo({left:card.offsetLeft-track.offsetLeft,behavior:'instant'})},{signal:this.life.signal})}disconnectedCallback(){this.life?.abort()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-offer-banner"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hc-countdown'))customElements.define('hc-countdown',class extends HTMLElement{connectedCallback(){let end=Date.parse(this.dataset.end),out=this.querySelector('[data-countdown]');if(!out||!Number.isFinite(end))return;let update=()=>{let remaining=Math.max(0,Math.floor((end-Date.now())/1000));out.hidden=remaining<=0;if(!remaining){clearInterval(this.timer);return;}out.textContent=Math.floor(remaining/3600)+'h : '+String(Math.floor(remaining%3600/60)).padStart(2,'0')+'m : '+String(remaining%60).padStart(2,'0')+'s';};update();this.timer=setInterval(update,1000);}disconnectedCallback(){clearInterval(this.timer);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-testimonials"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hc-testimonials'))customElements.define('hc-testimonials',class extends HTMLElement{connectedCallback(){this.track=this.querySelector('.hc-testimonials__track');this.cards=[...this.track.children];let dots=this.querySelector('.hc-testimonials__dots');dots.replaceChildren();this.dots=this.cards.map((_,i)=>{let d=document.createElement('button');d.type='button';d.dataset.testimonialIndex=i;d.setAttribute('aria-label','Show review '+(i+1));dots.append(d);return d;});this.onClick=e=>{let b=e.target.closest('[data-testimonial-dir],[data-testimonial-index]');if(!b)return;this.go(b.hasAttribute('data-testimonial-index')?Number(b.dataset.testimonialIndex):this.index+Number(b.dataset.testimonialDir));};this.onScroll=()=>{let step=this.cards[1]?this.cards[1].offsetLeft-this.cards[0].offsetLeft:this.track.clientWidth;this.index=Math.round(this.track.scrollLeft/step)||0;this.dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===this.index)));this.querySelector('[data-testimonial-dir="-1"]').disabled=this.track.scrollLeft<2;this.querySelector('[data-testimonial-dir="1"]').disabled=this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-2;};this.onSelect=e=>{let i=this.cards.findIndex(c=>c===e.target||c.contains(e.target));if(i>=0)this.go(i);};this.addEventListener('click',this.onClick);this.track.addEventListener('scroll',this.onScroll,{passive:true});document.addEventListener('shopify:block:select',this.onSelect);this.onScroll();}go(i){i=Math.max(0,Math.min(i,this.cards.length-1));if(this.cards[i])this.track.scrollTo({left:this.cards[i].offsetLeft-this.cards[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}disconnectedCallback(){this.removeEventListener('click',this.onClick);this.track.removeEventListener('scroll',this.onScroll);document.removeEventListener('shopify:block:select',this.onSelect);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pure-tones-community"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pure-tones-community')){
 customElements.define('pure-tones-community',class extends HTMLElement{
  connectedCallback(){
   this.life?.abort();
   this.life=new AbortController();
   this.addEventListener('shopify:block:select',event=>{
    const card=event.target.closest('.pt-community-card');
    const track=this.querySelector('.rf-comment-track');
    if(card&&track)track.scrollTo({left:track.scrollLeft+card.getBoundingClientRect().left-track.getBoundingClientRect().left,behavior:'instant'});
   },{signal:this.life.signal});
  }
  disconnectedCallback(){this.life?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reference-cart"]) return;
  try {
    
if(!customElements.get('tone-cart')){
  customElements.define('tone-cart',class extends HTMLElement{
    connectedCallback(){
      this.life=new AbortController();
      this.pending=new Map();
      this.running=false;
      this.unsynced=false;
      const options={signal:this.life.signal};
      this.classList.add('is-ready');
      this.addEventListener('click',event=>{
        const step=event.target.closest('[data-cart-step]');
        const remove=event.target.closest('[data-cart-remove]');
        if(step){
          const input=step.closest('[data-cart-line]').querySelector('[data-cart-quantity]');
          input.value=Math.max(1,Number(input.value||input.dataset.serverQuantity)+Number(step.dataset.cartStep));
          this.queue(input);
        }else if(remove){
          event.preventDefault();
          const input=remove.closest('[data-cart-line]').querySelector('[data-cart-quantity]');
          input.value=0;
          this.queue(input);
        }else if(event.target.closest('[data-cart-retry]')){
          this.recover();
        }
      },options);
      this.addEventListener('input',event=>{
        if(event.target.matches('[data-cart-quantity]'))this.queue(event.target);
      },options);
      this.addEventListener('change',event=>{
        if(!event.target.matches('[data-cart-quantity]'))return;
        if(!this.valid(event.target.value)){
          event.target.value=event.target.dataset.serverQuantity;
          this.showError(this.dataset.invalid);
        }
        this.queue(event.target);
      },options);
      this.addEventListener('keydown',event=>{
        if(event.key==='Enter'&&event.target.matches('[data-cart-quantity]')){
          event.preventDefault();
          event.target.blur();
          this.flush();
        }
      },options);
      this.addEventListener('submit',event=>{
        if(event.submitter?.name==='checkout'){
          if(this.running||this.pending.size||this.unsynced)event.preventDefault();
          return;
        }
        event.preventDefault();
        this.querySelectorAll('[data-cart-quantity]').forEach(input=>this.queue(input));
        this.flush();
      },options);
    }
    disconnectedCallback(){this.life?.abort();clearTimeout(this.debounce);}
    valid(value){return value.trim()!==''&&Number.isSafeInteger(Number(value))&&Number(value)>=0;}
    queue(input){
      if(!this.valid(input.value))return;
      const line=input.closest('[data-cart-line]');
      this.pending.set(line.dataset.key,{quantity:Number(input.value),identity:line.dataset.identity});
      line.querySelector('[data-cart-step="-1"]').disabled=Number(input.value)<=1;
      this.showError('');
      this.busy(true);
      clearTimeout(this.debounce);
      this.debounce=setTimeout(()=>this.flush(),220);
    }
    busy(value){
      this.classList.toggle('is-updating',value);
      this.querySelector('[data-cart-content]').setAttribute('aria-busy',String(value));
      const checkout=this.querySelector('[data-cart-checkout]');
      if(checkout)checkout.disabled=value||this.unsynced;
      if(value)this.querySelector('[data-cart-status]').textContent=this.dataset.updating;
    }
    showError(message){
      const error=this.querySelector('[data-cart-error]');
      error.textContent=message;
      error.hidden=!message;
    }
    async request(url,options={}){
      const requestURL=new URL(url,window.location.origin);
      const currentURL=new URL(window.location.href);
      for(const param of ['preview_theme_id','_fd']){
        if(currentURL.searchParams.has(param))requestURL.searchParams.set(param,currentURL.searchParams.get(param));
      }
      const response=await fetch(requestURL.toString(),{credentials:'same-origin',...options,signal:AbortSignal.timeout(12000)});
      const data=await response.json();
      if(!response.ok){
        const error=new Error(this.dataset.error);
        error.customerMessage=data.description||data.message||this.dataset.error;
        throw error;
      }
      return data;
    }
    async flush(){
      clearTimeout(this.debounce);
      if(this.running||!this.pending.size)return;
      this.running=true;
      this.busy(true);
      try{
        while(this.pending.size&&this.isConnected){
          const [key,change]=this.pending.entries().next().value;
          this.pending.delete(key);
          const data=await this.request(this.dataset.changeUrl,{
            method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({id:key,quantity:change.quantity,sections:[this.dataset.sectionId],sections_url:window.location.pathname+window.location.search})
          });
          let html=data.sections?.[this.dataset.sectionId];
          if(!html)html=await this.sectionHTML();
          this.render(html);
        }
        this.unsynced=false;
        this.querySelector('[data-cart-status]').textContent=this.dataset.updated;
      }catch(error){
        this.pending.clear();
        try{this.render(await this.sectionHTML());this.unsynced=false;}
        catch{this.unsynced=true;}
        this.querySelector('[data-cart-status]').textContent='';
        this.showError(error.customerMessage||this.dataset.error);
        this.querySelector('[data-cart-retry]').hidden=!this.unsynced;
      }finally{
        this.running=false;
        this.busy(false);
      }
    }
    async sectionHTML(){
      const url=new URL(this.dataset.cartUrl,window.location.origin);
      url.searchParams.set('sections',this.dataset.sectionId);
      const data=await this.request(url.toString());
      if(!data[this.dataset.sectionId])throw new Error(this.dataset.error);
      return data[this.dataset.sectionId];
    }
    render(html){
      const next=new DOMParser().parseFromString(html,'text/html').querySelector('tone-cart [data-cart-content]');
      if(!next)throw new Error(this.dataset.error);
      const content=this.querySelector('[data-cart-content]');
      const note=this.querySelector('[data-cart-note]')?.value;
      const noteOpen=this.querySelector('[data-cart-note-toggle]')?.open;
      const active=this.contains(document.activeElement)?document.activeElement:null;
      const focusKey=active?.closest('[data-cart-line]')?.dataset.key;
      const focusIdentity=active?.closest('[data-cart-line]')?.dataset.identity;
      const focusKind=active?.matches('[data-cart-quantity]')?'quantity':active?.dataset.cartStep;
      const noteFocused=active?.matches('[data-cart-note]');
      const pending=new Map();
      const lines=[...next.querySelectorAll('[data-cart-line]')];
      for(const [key,change] of this.pending){
        const exact=lines.find(line=>line.dataset.key===key);
        const candidates=lines.filter(line=>line.dataset.identity===change.identity);
        const line=exact||(candidates.length===1?candidates[0]:null);
        if(!line)throw new Error(this.dataset.error);
        pending.set(line.dataset.key,change);
      }
      content.innerHTML=next.innerHTML;
      content.dataset.itemCount=next.dataset.itemCount;
      this.pending=pending;
      for(const [key,change] of pending){
        const line=[...content.querySelectorAll('[data-cart-line]')].find(item=>item.dataset.key===key);
        line.querySelector('[data-cart-quantity]').value=change.quantity;
        line.querySelector('[data-cart-step="-1"]').disabled=change.quantity<=1;
      }
      if(note!==undefined&&this.querySelector('[data-cart-note]'))this.querySelector('[data-cart-note]').value=note;
      if(this.querySelector('[data-cart-note-toggle]'))this.querySelector('[data-cart-note-toggle]').open=!!noteOpen;
      document.querySelectorAll('.hm-cart-link span').forEach(count=>count.textContent=next.dataset.itemCount);
      if(focusKind){
        const line=[...content.querySelectorAll('[data-cart-line]')].find(item=>item.dataset.key===focusKey||item.dataset.identity===focusIdentity);
        const target=focusKind==='quantity'?line?.querySelector('[data-cart-quantity]'):line?.querySelector('[data-cart-step="'+focusKind+'"]');
        (target||line?.querySelector('[data-cart-quantity]')||content.querySelector('h1'))?.focus({preventScroll:true});
      }else if(noteFocused){this.querySelector('[data-cart-note]')?.focus({preventScroll:true});}
      this.busy(this.running);
    }
    async recover(){
      if(this.running)return;
      this.running=true;
      this.pending.clear();
      this.busy(true);
      try{
        this.render(await this.sectionHTML());
        this.unsynced=false;
        this.showError('');
        this.querySelector('[data-cart-retry]').hidden=true;
        this.querySelector('[data-cart-status]').textContent=this.dataset.updated;
      }catch{this.showError(this.dataset.error);this.unsynced=true;}
      finally{this.running=false;this.busy(false);}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reference-content"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('reference-section'))customElements.define('reference-section',class extends HTMLElement{connectedCallback(){this.life=new AbortController();this.addEventListener('click',e=>{const b=e.target.closest('[data-compare]');if(!b)return;this.querySelectorAll('[data-compare]').forEach(t=>t.setAttribute('aria-selected',String(t===b)));const type=b.dataset.compare;this.querySelector('[data-compare-title]').textContent=this.querySelector('[data-compare-title]').dataset[type];this.querySelectorAll('[data-single-cell]').forEach(c=>c.textContent=c.dataset[type+'Cell'])},{signal:this.life.signal})}disconnectedCallback(){this.life?.abort()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reference-page"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sound-quiz'))customElements.define('sound-quiz',class extends HTMLElement{connectedCallback(){this.life=new AbortController();this.answers={};this.addEventListener('click',e=>{const b=e.target.closest('[data-quiz-next]');if(!b)return;const step=b.closest('[data-quiz-step]').dataset.quizStep;if(b.dataset.quizAnswer)this.answers[step]=b.textContent.replace('→','').trim();this.querySelectorAll('[data-quiz-step]').forEach(s=>s.hidden=s.dataset.quizStep!==b.dataset.quizNext);this.querySelector('[data-quiz-result-label]').textContent=Object.values(this.answers).join(' · ');const next=this.querySelector(`[data-quiz-step="${b.dataset.quizNext}"] h2`);next.setAttribute('tabindex','-1');next.focus({preventScroll:true})},{signal:this.life.signal})}disconnectedCallback(){this.life?.abort()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reference-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('review-wall'))customElements.define('review-wall',class extends HTMLElement{connectedCallback(){this.life=new AbortController();this.addEventListener('click',e=>{const b=e.target.closest('[data-rating-filter]');if(!b)return;const rating=b.dataset.ratingFilter;this.querySelectorAll('[data-rating-filter]').forEach(f=>f.setAttribute('aria-pressed',String(f===b)));let found=0;this.querySelectorAll('.rf-wall-card').forEach(c=>{c.hidden=rating!=='all'&&c.dataset.rating!==rating;if(!c.hidden)found++});this.querySelector('.rf-filter-empty').hidden=found>0},{signal:this.life.signal});this.querySelector('[data-review-sort]').addEventListener('change',e=>{const cards=[...this.querySelectorAll('.rf-wall-card')];cards.sort((a,b)=>e.target.value==='default'?Number(a.dataset.order)-Number(b.dataset.order):e.target.value==='high'?Number(b.dataset.rating)-Number(a.dataset.rating):Number(a.dataset.rating)-Number(b.dataset.rating));cards.forEach(c=>this.querySelector('.rf-wall-grid').append(c))},{signal:this.life.signal})}disconnectedCallback(){this.life?.abort()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-card-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('review-card-carousel')) {
  customElements.define('review-card-carousel', class extends HTMLElement {
    connectedCallback() {
      this.life?.abort();
      this.resize?.disconnect();
      this.life = new AbortController();
      const signal = this.life.signal;
      this.track = this.querySelector('.rc-track');
      this.cards = [...this.querySelectorAll('.rc-card')];
      this.pendingIndex = null;
      if (!this.track || !this.cards.length) return;
      const stops = () => {
        const left = this.track.getBoundingClientRect().left;
        const inset = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        const end = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        return this.cards.reduce((positions, card) => {
          const position = Math.max(0, Math.min(end, this.track.scrollLeft + card.getBoundingClientRect().left - left - inset));
          if (!positions.length || Math.abs(position - positions[positions.length - 1]) > 1) positions.push(position);
          return positions;
        }, []);
      };
      const nearest = positions => positions.reduce((best, position, index) =>
        Math.abs(position - this.track.scrollLeft) < Math.abs(positions[best] - this.track.scrollLeft) ? index : best, 0);
      const move = direction => {
        const positions = stops();
        const current = this.pendingIndex ?? nearest(positions);
        const next = (current + direction + positions.length) % positions.length;
        this.pendingIndex = next;
        this.track.scrollTo({
          left: positions[next],
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
        if (Math.abs(this.track.scrollLeft - positions[next]) < 1) this.pendingIndex = null;
      };
      const release = () => { this.pendingIndex = null; };
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-review-step]');
        if (button) move(Number(button.dataset.reviewStep));
      }, {signal});
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, {signal});
      this.track.addEventListener('scrollend', release, {signal});
      this.track.addEventListener('pointerdown', release, {passive: true, signal});
      this.track.addEventListener('touchstart', release, {passive: true, signal});
      this.track.addEventListener('wheel', release, {passive: true, signal});
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.rc-card');
        if (card) {
          release();
          this.track.scrollTo({left: this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: 'instant'});
        }
      }, {signal});
      this.resize = new ResizeObserver(release);
      this.resize.observe(this.track);
    }
    disconnectedCallback() {
      this.life?.abort();
      this.resize?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
